import hljs from "highlight.js/lib/common";
import "highlight.js/styles/atom-one-dark.min.css";

/** Map file extension / basename → highlight.js language id (or null = no highlight). */
const EXT_LANG = {
  // js / ts
  js: "javascript", jsx: "javascript", mjs: "javascript", cjs: "javascript",
  ts: "typescript", tsx: "typescript",
  // python
  py: "python", pyi: "python", pyw: "python",
  // shell
  sh: "bash", bash: "bash", zsh: "bash", fish: "bash", ksh: "bash",
  env: "bash", gitignore: "bash", dockerignore: "bash", npmignore: "bash",
  // markup / data
  json: "json", json5: "json", jsonc: "json", ndjson: "json", geojson: "json",
  yaml: "yaml", yml: "yaml",
  toml: "ini", ini: "ini", cfg: "ini", conf: "ini", config: "ini", properties: "ini",
  gitconfig: "ini", editorconfig: "ini",
  xml: "xml", html: "xml", htm: "xml", xhtml: "xml", svg: "xml", vue: "xml", svelte: "xml",
  // css family
  css: "css", scss: "scss", sass: "scss", less: "less",
  // backends
  go: "go", rs: "rust", rb: "ruby", php: "php", java: "java", kt: "kotlin", kts: "kotlin",
  cs: "csharp", swift: "swift", c: "c", cpp: "cpp", cc: "cpp", cxx: "cpp",
  h: "c", hpp: "cpp", hh: "cpp", m: "objectivec", mm: "objectivec",
  pl: "perl", pm: "perl", lua: "lua", r: "r",
  // sql / schemas
  sql: "sql", graphql: "graphql", gql: "graphql",
  // misc
  md: "markdown", mdx: "markdown", markdown: "markdown",
  patch: "diff", diff: "diff",
  makefile: "makefile", mk: "makefile",
};

const BASENAME_LANG = {
  dockerfile: "dockerfile",
  containerfile: "dockerfile",
  makefile: "makefile",
  rakefile: "ruby",
  gemfile: "ruby",
  procfile: "yaml",
};

function fileExt(file) {
  const name = (file.name || "").toLowerCase();
  if (!name.includes(".")) return "";
  return name.split(".").pop();
}

/** Resolve a highlight.js language for the file, or null when we should render plain text. */
export function getLanguage(file) {
  const name = (file.name || "").toLowerCase();
  if (BASENAME_LANG[name]) return BASENAME_LANG[name];
  const ext = fileExt(file);
  return ext ? EXT_LANG[ext] || null : null;
}

const MAX_HIGHLIGHT_BYTES = 256 * 1024;

/** Returns highlighted HTML (string) or null when not applicable / too big / failed. */
export function highlight(text, lang) {
  if (!lang || typeof text !== "string") return null;
  if (text.length > MAX_HIGHLIGHT_BYTES) return null;
  if (!hljs.getLanguage(lang)) return null;
  try {
    return hljs.highlight(text, { language: lang, ignoreIllegals: true }).value;
  } catch {
    return null;
  }
}
